export default "__VITE_ASSET__CNwEUnee__"